import { QuestionID, QuestionnaireID } from "../types/Questionnaire";
import { AnswersByQuestionnaireType, AnswerValueType } from "../types/Answer";

export default (
  allAnswers: AnswersByQuestionnaireType,
  questionnaireId: QuestionnaireID,
  questionId: QuestionID,
): AnswerValueType =>
  allAnswers[questionnaireId] && allAnswers[questionnaireId][questionId];
